import Service, { inject as service } from '@ember/service';
import type AditoolsSiteService from '@ebiz/ember-aditools-site/services/aditools-site';

export default class CdpService extends Service {
  @service('aditools-site') declare siteconfig: AditoolsSiteService;

  getToolData() {
    const configUrl = this.siteconfig['ConfigUrl'] + '?id=' + new Date().getTime();
    return fetch(configUrl).then((response) => {
      // Load tool data from config file
      if (response.status === 404) {
        throw 'Failed with Invalid status ' + response.statusText;
      } else {
        return response.json().then((data) => {
          return data;
        });
      }
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    cdp: CdpService;
  }
}
